module.exports = __webpack_public_path__ + "static/tony-003-55aeda65a5f3cdeca60ff43786dde131.jpg";